import './statistiques.scss';
import React, { useEffect, useState } from 'react';
import AppelerApi from '../../../services/appeler-api.service';
import { FaClock } from 'react-icons/fa6';
import { FaChartBar, FaUsers, FaUserPlus, FaUserMinus, FaChartLine, FaPercentage, FaChevronLeft, FaChevronRight, FaRegCalendarAlt } from 'react-icons/fa';
import { FiActivity } from 'react-icons/fi';
import debounce from 'lodash.debounce'

const Statistiques = () => {
    const [currentMonth, setCurrentMonth] = useState(new Date());
    const [stats, setStats] = useState({
        ensemble:[
            {
                label: 'Total clients 1er du mois',
                valeur: '0',
                valeurMoisPrecedent: '0',
                evolution: '+0%',
                icon: <FaUsers />,
                marques: [
                    {
                        nom: "Hairnet+",
                        valeurMoisPrecedent: "0",
                        valeur: "0",
                        evolution: "0%"
                    },
                    {
                        nom: "LSCoiffure", 
                        valeurMoisPrecedent: "0",
                        valeur: "0",
                        evolution: "+0%"
                    },
                    {
                        nom: "LSInstitut",
                        valeurMoisPrecedent: "0",
                        valeur: "0",
                        evolution: "+0%"
                    }
                ]
            },
            {
                label: 'Nouveaux clients',
                valeur: '0',
                valeurMoisPrecedent: '0',
                evolution: '+0%',
                icon: <FaUserPlus />,
                marques: [
                    {
                        nom: "Hairnet+",
                        valeurMoisPrecedent: "0",
                        valeur: "0",
                        evolution: "0%"
                    },
                    {
                        nom: "LSCoiffure", 
                        valeurMoisPrecedent: "0",
                        valeur: "0",
                        evolution: "+0%"
                    },
                    {
                        nom: "LSInstitut",
                        valeurMoisPrecedent: "0",
                        valeur: "0",
                        evolution: "+0%"
                    }
                ]
            },
            {
                label: 'Clients perdus',
                valeur: '0',
                valeurMoisPrecedent: '0',
                evolution: '+0%',
                icon: <FaUserMinus />,
                marques: [
                    {
                        nom: "Hairnet+",
                        valeurMoisPrecedent: "0",
                        valeur: "0",
                        evolution: "0%"
                    },
                    {
                        nom: "LSCoiffure", 
                        valeurMoisPrecedent: "0",
                        valeur: "0",
                        evolution: "+0%"
                    },
                    {
                        nom: "LSInstitut",
                        valeurMoisPrecedent: "0",
                        valeur: "0",
                        evolution: "+0%"
                    }
                ]
            },
            {
                label: 'Différence nette',
                valeur: '0',
                valeurMoisPrecedent: '0',
                evolution: '+0%',
                icon: <FaChartLine />,
                marques: [
                    {
                        nom: "Hairnet+",
                        valeurMoisPrecedent: "0",
                        valeur: "0",
                        evolution: "0%"
                    },
                    {
                        nom: "LSCoiffure", 
                        valeurMoisPrecedent: "0",
                        valeur: "0",
                        evolution: "+0%"
                    },
                    {
                        nom: "LSInstitut",
                        valeurMoisPrecedent: "0",
                        valeur: "0",
                        evolution: "+0%"
                    }
                ]
            },
            {
                label: 'Taux de churn',
                valeur: '0',
                valeurMoisPrecedent: '0',
                evolution: '+0%',
                icon: <FaPercentage />,
                marques: [
                    {
                        nom: "Hairnet+",
                        valeurMoisPrecedent: "0",
                        valeur: "0",
                        evolution: "0%"
                    },
                    {
                        nom: "LSCoiffure", 
                        valeurMoisPrecedent: "0",
                        valeur: "0",
                        evolution: "+0%"
                    },
                    {
                        nom: "LSInstitut",
                        valeurMoisPrecedent: "0",
                        valeur: "0",
                        evolution: "+0%"
                    }
                ]
            },
        ],
        generales: [
            {
                label: 'Total clients actuel',
                icon: <FaUsers />,
                valeurTotal: '0 jours',
                valeurHairnet: '0 jours',
                valeurLscoiffure: '0 jours',
                valeurLsinstitut: '0 jours',
            },
            {
                label: "Durée moyenne d'abonnement",
                icon: <FaClock />,
                valeurTotal: '0 jours',
                valeurHairnet: '0 jours',
                valeurLscoiffure: '0 jours',
                valeurLsinstitut: '0 jours',
            }
        ],
        tableaux: [
            {
                label: 'Clients N-1',
                valeurTotal: 0,
                evolution: 0,
            },
            {
                label: 'Clients M-1',
                valeurTotal: 0,
                evolution: 0,
            },
            {
                label: 'Clients M',
                valeurTotal: 0
            },
        ],
        mrr: 0,
        acquisition: 0
    });

    const formattedMonth = currentMonth.toLocaleString("fr-FR", { month: "long", year: "numeric" });
    const prevMonth = new Date(currentMonth);
    prevMonth.setMonth(prevMonth.getMonth() - 1);
    const formattedPrevMonth = prevMonth.toLocaleString("fr-FR", { month: "long", year: "numeric" });

    const aujourdhui = new Date();
    const estAvantMoisChoisi = aujourdhui.getFullYear() < currentMonth.getFullYear() ||
        (aujourdhui.getFullYear() === currentMonth.getFullYear() && aujourdhui.getMonth() < currentMonth.getMonth());

    const hauteurMaxTableauPixel = 400;
    const maxValeurTotal = Math.max(...stats.tableaux.map(row => row.valeurTotal));
    const maxValeurAbscisse = Math.ceil(maxValeurTotal / 500 ) * 500;
    const valeurIntervalle = 500;
    const intervalleAbscisse = [];
    for (let val = maxValeurAbscisse; val >= 0; val -= valeurIntervalle) {
        intervalleAbscisse.push(val);
    }
    const ligneOrdonne = intervalleAbscisse.map((_, i) => (i / (intervalleAbscisse.length - 1)) * 100);

    const handlePrevMonth = () => {
        setCurrentMonth(prev => {
            const newDate = new Date(prev);
            newDate.setMonth(newDate.getMonth() - 1);
            return newDate;
        });
    };

    const handleNextMonth = () => {
        setCurrentMonth(prev => {
            const newDate = new Date(prev);
            newDate.setMonth(newDate.getMonth() + 1);
            return newDate;
        });
    };

    const appliquerModificationStatistique = debounce((valeur, champ) => {
        AppelerApi.post('/modifier-statistiques', { date: currentMonth, champ, valeur }).then(res => {
        })
    }, 500)

    const modifierStatistique = (valeur, champ) => {
        if (!valeur) {
            valeur = 0;
        }
        stats[champ.toLowerCase()] = valeur;
        setStats({ ...stats });
        appliquerModificationStatistique(valeur, champ);
    }

    useEffect(() => {
        AppelerApi.get('/lire-statistiques', { date: currentMonth }).then(res => {
            const nouvellesStats = res.stats;

            setStats(prevStats => ({
                ensemble: prevStats.ensemble.map((item, index) => ({
                    ...item,
                    valeur: nouvellesStats.ensemble?.[index]?.valeur ?? item.valeur,
                    valeurMoisPrecedent: nouvellesStats.ensemble?.[index]?.valeurMoisPrecedent ?? item.valeurMoisPrecedent,
                    evolution: nouvellesStats.ensemble?.[index]?.evolution ?? item.evolution,
                    marques: nouvellesStats.ensemble?.[index]?.marques ?? item.marques
                })),
                generales: prevStats.generales.map((item, index) => ({
                    ...item,
                    valeurTotal: nouvellesStats.generales?.[index]?.valeurTotal ?? item.valeurTotal,
                    valeurHairnet: nouvellesStats.generales?.[index]?.valeurHairnet ?? item.valeurHairnet,
                    valeurLscoiffure: nouvellesStats.generales?.[index]?.valeurLscoiffure ?? item.valeurLscoiffure,
                    valeurLsinstitut: nouvellesStats.generales?.[index]?.valeurLsinstitut ?? item.valeurLsinstitut
                })),
                tableaux: prevStats.tableaux.map((item, index) => ({
                    ...item,
                    valeurTotal: nouvellesStats.tableaux?.[index]?.valeurTotal ?? item.valeurTotal,
                    evolution: nouvellesStats.tableaux?.[index]?.evolution ?? item.evolution
                })),
                mrr: nouvellesStats?.mrr ?? 0,
                acquisition: nouvellesStats?.acquisition ?? 0,
            }));
        });
    }, [currentMonth]);

    return (
        <div className="conteneur-statistiques">
            <h1>Statistiques</h1>
            <div className="card">
                <div className="header">
                    <FaChartBar className="icon" />
                    <h2>Statistiques Générales</h2>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>Métrique</th>
                            <th className="center">Hairnet+</th>
                            <th className="center">LSCoiffure</th>
                            <th className="center">LSInstitut</th>
                            <th className="evolution mois">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stats.generales.map((row, i) => (
                            <React.Fragment key={i}>
                                <tr>
                                    <td>
                                        <span className="icon">{row.icon}</span>
                                        {row.label}
                                    </td>
                                    <td className="center">{row.valeurHairnet}</td>
                                    <td className="center ">{row.valeurLscoiffure}</td> 
                                    <td className="center">{row.valeurLsinstitut}</td>
                                    <td className="evolution mois">{row.valeurTotal}</td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="donnees-saisir card">
                <div className="header">
                    <FaChartBar className="icon" />
                    <h2>Données à saisir</h2>
                    <div className="month-switcher">
                        <button onClick={handlePrevMonth} className="nav-btn">
                            <FaChevronLeft className="icon" />
                        </button>
                        <div className="month-display">
                            <FaRegCalendarAlt className="calendar-icon" />
                            <span className="month-text">{formattedMonth}</span>
                        </div>
                        <button onClick={handleNextMonth} className="nav-btn">
                            <FaChevronRight className="icon" />
                        </button>
                    </div>
                </div>
                <div className="container-donnees">
                    <div>
                        <div>
                            <label>MRR (Monthly Recurring Revenue)</label>
                            <div className="input">
                                <input type="number" placeholder="0" disabled={estAvantMoisChoisi} value={stats.mrr} onChange={e => modifierStatistique(e.target.value, 'Mrr')} />
                                <span>€</span>
                            </div>
                        </div>
                        
                        <div>
                            <label>Coût d'acquisition client</label>
                            <div className="input">
                                <input type="number" placeholder="0" disabled={estAvantMoisChoisi} value={stats.acquisition} onChange={e => modifierStatistique(e.target.value, 'Acquisition')} />
                                <span>€</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <label>ARR (Annual Recurring Revenue)</label>
                            <div className="input">
                                <input disabled type="number" id="arr" placeholder="0" value={stats.mrr * 12} />
                                <span>€</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="vue-ensemble card">
                <div className="header">
                    <div className="icon">
                        <FiActivity />
                    </div>
                    <h2>Vue d'ensemble</h2>
                    <div className="month-switcher">
                        <button onClick={handlePrevMonth} className="nav-btn">
                            <FaChevronLeft className="icon" />
                        </button>
                        <div className="month-display">
                            <FaRegCalendarAlt className="calendar-icon" />
                            <span className="month-text">{formattedMonth}</span>
                        </div>
                        <button onClick={handleNextMonth} className="nav-btn">
                            <FaChevronRight className="icon" />
                        </button>
                    </div>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>Métrique</th>
                            <th className="center">{formattedPrevMonth}</th>
                            <th className="center mois">{formattedMonth}</th>
                            <th className="evolution">Évolution</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stats.ensemble.map((row, i) => (
                            <React.Fragment key={i}>
                                <tr className="main-row">
                                    <td>
                                        <span className="icon">{row.icon}</span>
                                        {row.label}
                                    </td>
                                    <td className="center">{row.valeurMoisPrecedent}</td>
                                    <td className="center mois">{row.valeur}</td> 
                                    <td className={`evolution ${row.evolution?.startsWith('+') ? 'vert' : 'rouge'}`}>
                                        {row.evolution}
                                    </td>
                                </tr>
                                
                                {row.marques && row.marques.map((marque, j) => (
                                    <tr key={`${i}-${j}`} className="sub-row">
                                        <td className="sub-label">
                                            <span className="sub-indent">{marque.nom}</span>
                                        </td>
                                        <td className="center sub-value">{marque.valeurMoisPrecedent}</td>
                                        <td className="center mois sub-value">{marque.valeur}</td>
                                        <td className={`evolution sub-evolution ${marque.evolution?.startsWith('+') ? 'vert' : 'rouge'}`}>
                                            {marque.evolution}
                                        </td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="tableau card">
                <div className="header">
                    <FaChartBar className="icon" />
                    <h2>Évolution du nombre de clients</h2>
                    <div className="month-switcher">
                        <button onClick={handlePrevMonth} className="nav-btn">
                            <FaChevronLeft className="icon" />
                        </button>
                        <div className="month-display">
                            <FaRegCalendarAlt className="calendar-icon" />
                            <span className="month-text">{formattedMonth}</span>
                        </div>
                        <button onClick={handleNextMonth} className="nav-btn">
                            <FaChevronRight className="icon" />
                        </button>
                    </div>
                </div>
                <div className="chart-container">
                    <div className="chart-wrapper">
                        <div className="y-axis">
                            {intervalleAbscisse.map((label, id) => (
                                <div key={id} className="y-axis-label">{label}</div>
                            ))}
                        </div>
                        <div className="chart-area">
                            <div className="grid-lines">
                                {ligneOrdonne.map((bottom, id) => (
                                    <div key={id} className="grid-line" style={{ bottom: `${bottom}%` }}></div>
                                ))}
                            </div>
                            <div className="bars-container">
                                {stats.tableaux.map((row, i) => {
                                    const pourcentage = (row.valeurTotal / maxValeurAbscisse) * 100;
                                    const hauteurBarre = (pourcentage / 100) * hauteurMaxTableauPixel;
                                    return (
                                        <div key={i} className="bar-container">
                                            <div className="bar-wrapper">
                                                {row.evolution && (
                                                    <div className="bar-percentage">{row.evolution}</div>
                                                )}
                                                <div className="bar-value">{row.valeurTotal}</div>
                                                <div className="bar" style={{height: `${hauteurBarre}px`}}></div>
                                                <div className="bar-label">{row.label}</div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Statistiques;